/**
 * Generato automaticamente.
 * framework-cfg-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { AnagraficaFasiDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene l'elenco di anagrafica fasi
 * @summary Elenco Anagrafica Fasi
 */
export const getAnagraficaFasi = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<AnagraficaFasiDTO[]>(
    {
      url: `/framework-cfg-procedimenti/anagrafica-fasi`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetAnagraficaFasiQueryKey = () =>
  [`/framework-cfg-procedimenti/anagrafica-fasi`] as const;

export const getGetAnagraficaFasiQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnagraficaFasi>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnagraficaFasi>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getAnagraficaFasi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAnagraficaFasiQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAnagraficaFasi>>
  > = ({ signal }) => getAnagraficaFasi(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetAnagraficaFasiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAnagraficaFasi>>
>;
export type GetAnagraficaFasiQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Anagrafica Fasi
 */
export const useGetAnagraficaFasi = <
  TData = Awaited<ReturnType<typeof getAnagraficaFasi>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAnagraficaFasi>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAnagraficaFasiQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
